import React, { Component } from "react";
import "./inner.scss";
import CheckLength from "../../../components/common/checkLength";

class FAATableData extends Component {
  constructor() {
    super();
    this.state = {
      rows: [
        {
          Serial: "",
          Category: "Frozen yoghurt",
          ForecastAccuracy: "%",
          ForecastAccuracyYTD: "%",
          ForecastAccuracyTarget: "%",
        },
        {
          Serial: "",
          Category: "Frozen yoghurt",
          ForecastAccuracy: "%",
          ForecastAccuracyYTD: "%",
          ForecastAccuracyTarget: "%",
        },
        {
          Serial: "",
          Category: "Frozen yoghurt",
          ForecastAccuracy: "%",
          ForecastAccuracyYTD: "%",
          ForecastAccuracyTarget: "%",
        },
        {
          Serial: "t",
          Category: "Frozen yoghurt",
          ForecastAccuracy: "%",
          ForecastAccuracyYTD: "%",
          ForecastAccuracyTarget: "%",
        },
        {
          Serial: "",
          Category: "Frozen yoghurt",
          ForecastAccuracy: "%",
          ForecastAccuracyYTD: "%",
          ForecastAccuracyTarget: "%",
        },
      ],
    };
  }

  render() {
    return (
      <>
        <table className="forcast-acuraccy-table">
          <thead>
            <tr>
              <th className="tables-cell months-header-cell">Serial</th>
              <th className="tables-cell months-header-cell">Category</th>
              <th className="tables-cell months-header-cell">
                Forecast Accuracy 2019
              </th>
              <th className="tables-cell months-header-cell">
                Forecast Accuracy YTD 2020
              </th>
            </tr>
          </thead>
          <tbody>
            {this.props.data.ForecastAccuracyYtd
              ? this.props.data.ForecastAccuracyYtd.map((item, index) => (
                  <tr key={index} className="">
                    <td className="tables-cell year-column">{index + 1}</td>
                    <td className="tables-cell">{item.Category}</td>
                    <td className="tables-cell">
                      {this.props.ForecastAccuracyPreviousYear
                        ? this.props.ForecastAccuracyPreviousYear[index]
                        : "0%"}
                    </td>
                    <td className="tables-cell">
                      {CheckLength(item.Accuracy)}%
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </table>
      </>
    );
  }
}
export default FAATableData;
